import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import { DiseaseType, IcdCodeType } from "../../../constants/ICD10";
import ICD10 from "../components/ICD10";
import { DiseaseTypeResponse, IcdCodeTypeResponse } from "../../../models/api/ICD10";
import { getDiseaseTypeCall, getIcdCodeTypeData } from "../../../actions/ICD10";

const getIcdCodeType = (icdCodeTypeState: IcdCodeTypeResponse) => {
  const result = icdCodeTypeState.response;
  return result;
};

const getDiseaseType = (disaseTypeState: DiseaseTypeResponse) => {
  const result = disaseTypeState.response;
  return result;
};

const mapStateToProps = ({
  disaseTypeState,
  icdCodeTypeState,
  loggedInUserState
}: ApplicationState) => ({
  diseaseTypeResp: getDiseaseType(disaseTypeState) as DiseaseType[],
  icdCodeDataType: getIcdCodeType(icdCodeTypeState) as IcdCodeType[],
  loggedInUserState: loggedInUserState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getIcdeCodeDataType: () => {
      dispatch(getIcdCodeTypeData());
    },
    getDiseaseTypeData: (diseaseIdentifier: string) => {
      dispatch(getDiseaseTypeCall(diseaseIdentifier));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ICD10);
